<template>
  <component :is="commentComponent" v-bind="$attrs">
    <template v-slot:empty>
      <slot name="empty"></slot>
    </template>
  </component>
</template>

<script>
// Commponents
import TpComment from './pc/tp-comment.vue';
import TmComment from './mobile/tm-comment.vue';

// Utils
import pageThemeColor from './mixins/pageThemeColor.js';
import {
  checkMobileEnv,
  ATTACHMENT_MAX_SIZE,
  ATTACHMENT_MAX_SIZE_KEY,
  RECENTLY_MENTIONED_USERS_KEY,
  RECENTLY_MENTIONED_USERS_LIMIT,
  checkDirty,
} from '../core';
// import mockUserList from '../mock/recentlyMentionedUsers.js';

// styles
import '../core/assets/base-common.css';
import '../core/assets/base.css';

export default {
  name: 'TComment',
  props: {
    isMobile: {
      type: Boolean || null || undefined,
      default: null,
    },
    pageUrl: {
      type: String,
      defaut: '',
    },
  },
  provide() {
    return {
      // pageId() {
      //   return this.pageId;
      // },
      // dataId() {
      //   return this.dataId;
      // },
      // dimension() {
      //   return this.dimension;
      // },
      // commentTitle() {
      //   return this.commentTitle;
      // },
      /**
       * 用于发通知的链接地址，即当前`location.href`
       *  - Web 框架中（默认启用通知，也可关闭，一般不会关闭，看未来需求）
       *    - 需要功能页面传参`pageUrl`，不传则无法定位该功能页面，因此不发通知
       *    - 如果关闭，则返空
       *  - 非 Web 框架的三方系统中，不需要参数`pageUrl`
       *    - 已启用：location.href
       *    - 已禁用：反空
       */
      notificationLink: () => {
        if (this.$commentOptions.disableNotifications) {
          return '';
        }
        // 开启通知的情况
        else {
          // 在 Web 框架中，需要子应用页面地址
          if (this.$commentOptions.webFramework) {
            return this.pageUrl && this.pageUrl.trim() ? location.href : '';
          }
        }
        return location.href;
      },
      pageUrl: this.pageUrl || '',
      getAttachmentMaxSize: () => {
        return this.attachmentMaxSize;
      },
      getRecentlyMentionedUsers: () => this.recentlyMentionedUsers,
      updateRecentlyMentionedUsers: item => {
        // 去重，顶部push压栈，更新当前变量，更新到数据库
        const newList = [
          item,
          ...this.recentlyMentionedUsers.filter(n => n.UserID !== item.UserID),
        ].slice(0, RECENTLY_MENTIONED_USERS_LIMIT);
        this.recentlyMentionedUsers = newList;
        this.savePersennelMentioned();
      },
      emitEvent: (code, ...data) => {
        this.$emit(code, ...data);
      },
    };
  },
  components: {
    TpComment,
    TmComment,
  },
  mixins: [pageThemeColor],
  data() {
    return {
      attachmentMaxSize: ATTACHMENT_MAX_SIZE,
      recentlyMentionedUsers: [],
    };
  },
  computed: {
    commentComponent() {
      const _isMobile =
        typeof this.isMobile === 'boolean'
          ? this.isMobile
          : checkMobileEnv(window && window.navigator.userAgent);
      console.log('isMobile', _isMobile);
      return _isMobile ? TmComment : TpComment;
    },
  },
  created() {
    this.init();
  },
  methods: {
    checkDirty() {
      return checkDirty(this.$el);
    },
    async init() {
      try {
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl('WRP-Runtime-GetUserProfile'),
          type: 'post',
          data: {
            profileKey: [
              ATTACHMENT_MAX_SIZE_KEY,
              RECENTLY_MENTIONED_USERS_KEY,
            ].join(','),
          },
        });

        if (!data || data.state !== '1') {
          return;
        }
        const _data_ = data.data;
        this.attachmentMaxSize =
          _data_[ATTACHMENT_MAX_SIZE_KEY] || ATTACHMENT_MAX_SIZE;
        this.recentlyMentionedUsers = JSON.parse(
          _data_[RECENTLY_MENTIONED_USERS_KEY] || '[]',
        );
        console.log(
          `UserProfile${ATTACHMENT_MAX_SIZE_KEY}=${this.attachmentMaxSize}`,
        );
        // TODO mock
        // if (!this.recentlyMentionedUsers.length) {
        //   this.recentlyMentionedUsers = mockUserList;
        // }
      } catch (error) {
        console.log(error);
      }
    },
    /**将本次提及人员记录下来（更新到数据库）*/
    async savePersennelMentioned() {
      try {
        await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl(
            'WRP-Runtime-SaveUserStringProfile',
          ),
          method: 'POST',
          data: {
            profileKey: RECENTLY_MENTIONED_USERS_KEY,
            profileValue: JSON.stringify(this.recentlyMentionedUsers),
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
.teld-comment * {
  box-sizing: border-box;
}
</style>
